import { cadOpType } from "lib/operations/factory";
import { EditDataCommand } from "./edit-base";

export class PprismEditDataCommand extends EditDataCommand {
    protected opType = cadOpType.EDITRPRISM;
}